// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".featured-city[data-v-7a4e3e77]{position:relative;border-radius:.5rem;height:350px;background-size:cover!important;background-position:50%!important}.featured-city .overlay[data-v-7a4e3e77]{position:absolute;width:100%;bottom:0;border-bottom-right-radius:.5rem;border-bottom-left-radius:.5rem;height:244px;background:linear-gradient(180deg,hsla(0,0%,100%,.01),#1d293e)}", ""]);
// Exports
module.exports = exports;
